<template>
    <div>
        <hero></hero>
        <i-support></i-support>
        <l-footer></l-footer>
    </div>
</template>

<script>
    export default {
        name: "Support"
    }
</script>

<style scoped>

</style>
